import { ApolloError } from '@apollo/client';

import {
  getGraphQLErrorsByStatusCode,
  getUserFacingErrorMessages,
  GraphQLStatusCodes,
} from '@/graphql/errors';

import { SalesforceConnectionQuery } from './graphql/SalesforceIntegration.generated';

export type SalesforceConnection = NonNullable<
  SalesforceConnectionQuery['salesforceConnection']
>;

export function salesforceError(error: unknown) {
  if (error instanceof ApolloError) {
    const message = getUserFacingErrorMessages(error)[0];
    if (message) return message;
    if (
      getGraphQLErrorsByStatusCode(error, GraphQLStatusCodes.FORBIDDEN)
        .length ||
      getGraphQLErrorsByStatusCode(error, GraphQLStatusCodes.UNAUTHORIZED)
        .length
    )
      return 'A Luminary administrator must configure this integration.';
  }
  return 'Unable to update Salesforce. Check the configuration and try again.';
}

export function isSalesforceDomain(value: string) {
  return /^(https:\/\/)?([a-z0-9]([a-z0-9-]*[a-z0-9])?\.)+(salesforce\.com|force\.com)\/?$/.test(
    value.trim().toLowerCase()
  );
}
